export type Drama = {
  id: string;
  title: string;
  type: "电视剧" | "电影";
  category: "tv" | "movie";
  isClassic: boolean;
  cover: string;
  banner: string;
  year: number;
  region: string;
  genres: string[];
  cast: string[];
  director: string;
  status: string;
  rating: number;
  popularity: number;
  updateTime: string;
  synopsis: string;
  tags: string[];
  recommendIds: string[];
};

export const dramas: Drama[] = [
  {
    id: "d001",
    title: "长风渡月",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20costume%20drama%20poster%20art%2C%20silhouette%20of%20a%20young%20swordsman%20under%20a%20full%20moon%20above%20misty%20mountains%2C%20deep%20navy%20and%20warm%20amber%20color%20palette%2C%20minimalist%20elegant%20background%2C%20editorial%20illustration%20style%2C%20high%20detail&width=400&height=600&seq=drama-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%2C%20dramatic%20sky%20with%20deep%20navy%20clouds%20and%20warm%20amber%20lantern%20glow%2C%20stylized%20cinematic%20atmosphere%2C%20artistic%20abstract%20composition%2C%20painterly%20high%20detail&width=1600&height=700&seq=banner-01&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "爱情", "剧情"],
    cast: ["林清源", "苏晚晴", "顾长风"],
    director: "陈默然",
    status: "全 40 集 · 已完结",
    rating: 8.9,
    popularity: 9860,
    updateTime: "2025-09-28",
    synopsis:
      "乱世之中，将门之女沈知微被迫替嫁入赘的寒门书生，两人由猜忌到相知，在朝堂权谋与家国危难之间携手并肩。长风渡口的一场月下之约，牵出一段跨越十年、横贯三朝的家国传奇。剧集以细腻的人物刻画与恢弘的时代背景，讲述普通人如何在乱世中守住所爱、守护心中明月。",
    tags: ["权谋", "先婚后爱", "家国情怀"],
    recommendIds: ["d004", "d012", "d010"],
  },
  {
    id: "d002",
    title: "都市迷城",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20suspense%20thriller%20poster%20art%2C%20lonely%20figure%20standing%20in%20rainy%20neon%20city%20alley%2C%20deep%20navy%20shadows%20with%20amber%20street%20light%2C%20moody%20minimalist%20background%2C%20cinematic%20illustration%20high%20detail&width=400&height=600&seq=drama-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Rainy%20modern%20city%20skyline%20at%20night%2C%20deep%20navy%20buildings%20with%20warm%20amber%20window%20lights%20reflected%20on%20wet%20streets%2C%20stylized%20cinematic%20mood%2C%20artistic%20abstract%20urban%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-02&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    cast: ["江若彤", "白景行", "温以宁"],
    director: "沈嘉木",
    status: "更新至 24 集",
    rating: 8.6,
    popularity: 9120,
    updateTime: "2025-10-12",
    synopsis:
      "一桩看似普通的失踪案，撕开了繁华都市光鲜表象下的隐秘裂痕。刑警队长陆行舟与犯罪心理画像师程微联手追查，却发现案件背后牵扯出十年前一桩尘封旧案。迷城之中，每个人都在隐藏秘密，真相究竟埋在多深的地方？",
    tags: ["刑侦", "心理战", "都市"],
    recommendIds: ["d006", "d014", "d011"],
  },
  {
    id: "d003",
    title: "星河彼岸",
    type: "电影",
    category: "movie",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20space%20movie%20poster%20art%2C%20lone%20astronaut%20silhouette%20before%20a%20vast%20glowing%20planet%2C%20deep%20navy%20space%20with%20warm%20amber%20light%2C%20minimalist%20cinematic%20composition%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Deep%20space%20nebula%20with%20a%20distant%20glowing%20planet%2C%20deep%20navy%20cosmos%20and%20warm%20amber%20starlight%2C%20stylized%20cinematic%20sci-fi%20atmosphere%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-03&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "剧情", "冒险"],
    cast: ["陆星辰", "何知秋"],
    director: "叶南舟",
    status: "已上映",
    rating: 8.4,
    popularity: 8760,
    updateTime: "2025-08-15",
    synopsis:
      "一支深空探测队在猎户座边缘捕捉到一段来自六十年前的信号。为了寻找信号源头，宇航员江野独自驾驶飞船穿越虫洞。在星河彼岸，他遇见的不是外星文明，而是人类文明曾经遗失的另一段历史。一部关于孤独、记忆与归途的科幻寓言。",
    tags: ["硬科幻", "太空", "人文"],
    recommendIds: ["d013", "d007", "d009"],
  },
  {
    id: "d004",
    title: "江湖夜雨",
    type: "电视剧",
    category: "tv",
    isClassic: true,
    cover:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%20art%2C%20lone%20swordsman%20in%20a%20bamboo%20forest%20under%20falling%20rain%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20minimalist%20ink%20painting%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20bamboo%20forest%20in%20the%20rain%20at%20dusk%2C%20deep%20navy%20mist%20and%20warm%20amber%20light%20rays%2C%20stylized%20ink%20wash%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-04&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["武侠", "剧情", "古装"],
    cast: ["顾长风", "楚见月", "白景行"],
    director: "陈默然",
    status: "全 36 集 · 已完结",
    rating: 9.1,
    popularity: 7750,
    updateTime: "2023-11-02",
    synopsis:
      "江湖夜雨十年灯，仗剑天涯为故人。退隐多年的剑客叶寒江被一封信重新卷入恩怨漩涡，昔日同门反目成仇，故人之女却成了他要保护的仇家血脉。刀光剑影之外，真正难渡的是人心。一部讲述江湖道义与个人抉择的经典武侠剧。",
    tags: ["经典", "江湖", "宿命"],
    recommendIds: ["d001", "d010", "d012"],
  },
  {
    id: "d005",
    title: "青春纪事",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%20art%2C%20group%20of%20students%20walking%20through%20a%20sunlit%20school%20corridor%2C%20warm%20amber%20and%20soft%20navy%20tones%2C%20minimalist%20nostalgic%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Golden%20hour%20sunlight%20through%20school%20classroom%20windows%2C%20warm%20amber%20glow%20with%20soft%20navy%20shadows%2C%20nostalgic%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-05&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "爱情", "剧情"],
    cast: ["苏晚晴", "何知秋", "温以宁"],
    director: "沈嘉木",
    status: "全 24 集 · 已完结",
    rating: 7.9,
    popularity: 6980,
    updateTime: "2024-07-20",
    synopsis:
      "高二那年转学来的程知遥，遇见了总在走廊尽头弹吉他的少年。三年高中、一场高考、一次分别，青春的纪念册里写满了来不及说的话。多年后同学重聚，他们才发现，那间洒满阳光的教室，藏着所有人最想回去的时光。",
    tags: ["校园", "成长", "治愈"],
    recommendIds: ["d015", "d017", "d007"],
  },
  {
    id: "d006",
    title: "暗夜追凶",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20investigation%20drama%20poster%20art%2C%20detective%20silhouette%20holding%20a%20flashlight%20in%20a%20dark%20alley%2C%20deep%20navy%20black%20with%20cold%20amber%20accents%2C%20minimalist%20cinematic%20background%2C%20high%20detail&width=400&height=600&seq=drama-cover-06&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Dark%20city%20alley%20at%20midnight%20lit%20by%20a%20single%20amber%20lamp%2C%20deep%20navy%20shadows%20and%20mist%2C%20stylized%20crime%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-06&orientation=landscape",
    year: 2024,
    region: "中国香港",
    genres: ["犯罪", "悬疑", "动作"],
    cast: ["陆星辰", "江若彤"],
    director: "叶南舟",
    status: "全 30 集 · 已完结",
    rating: 8.7,
    popularity: 8210,
    updateTime: "2024-12-05",
    synopsis:
      "连续七年，每逢月圆之夜，城市都会发生一起手法相同的凶案。即将退休的老刑警与年轻的痕迹专家组成临时搭档，抽丝剥茧，追踪一个比想象中更了解他们的人。当真相浮出水面，猎人与猎物的身份彻底颠倒。",
    tags: ["悬疑", "高能", "反转"],
    recommendIds: ["d002", "d014", "d011"],
  },
  {
    id: "d007",
    title: "山海秘闻",
    type: "电影",
    category: "movie",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20art%2C%20mythical%20creature%20emerging%20from%20ancient%20mountains%2C%20deep%20navy%20and%20warm%20amber%20color%20palette%2C%20minimalist%20epic%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ancient%20mythical%20mountain%20range%20with%20strange%20glowing%20beasts%20in%20the%20mist%2C%20deep%20navy%20sky%20and%20warm%20amber%20aura%2C%20stylized%20fantasy%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-07&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["奇幻", "冒险", "动作"],
    cast: ["白景行", "楚见月"],
    director: "叶南舟",
    status: "已上映",
    rating: 7.8,
    popularity: 7020,
    updateTime: "2024-10-01",
    synopsis:
      "古籍修复师苏砚意外发现《山海经》里记载的异兽竟真实存在于一座被雾气封锁的古城。为了找到失踪的兄长，他与考古队深入秘境，揭开了一个关于守护与献祭的古老盟约。当秘闻照进现实，人类该选择敬畏还是征服？",
    tags: ["国风奇幻", "寻秘", "视觉大片"],
    recommendIds: ["d003", "d010", "d013"],
  },
  {
    id: "d008",
    title: "医者仁心",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20art%2C%20surgeon%20in%20a%20hospital%20corridor%20under%20cold%20light%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20minimalist%20clean%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-08&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Modern%20hospital%20corridor%20at%20night%20with%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20clean%20minimal%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-08&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "医疗"],
    cast: ["温以宁", "陆星辰", "林清源"],
    director: "沈嘉木",
    status: "全 42 集 · 已完结",
    rating: 8.5,
    popularity: 6540,
    updateTime: "2023-06-18",
    synopsis:
      "急诊科医生周慎在三十岁那年迎来人生最大的考验：一场突发公共卫生事件、一位至亲的病人、一次艰难的手术抉择。白大褂之下，医生也是普通人。剧集以真实的医疗细节与克制的情感表达，致敬每一位在生死线上奔跑的人。",
    tags: ["现实题材", "职业", "感动"],
    recommendIds: ["d015", "d009", "d005"],
  },
  {
    id: "d009",
    title: "归途列车",
    type: "电影",
    category: "movie",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Emotional%20drama%20movie%20poster%20art%2C%20lone%20traveler%20with%20a%20suitcase%20on%20an%20empty%20train%20platform%2C%20deep%20navy%20dusk%20and%20warm%20amber%20lights%2C%20minimalist%20nostalgic%20background%2C%20high%20detail&width=400&height=600&seq=drama-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Empty%20railway%20station%20platform%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20amber%20platform%20lamps%2C%20melancholic%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-09&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    cast: ["顾长风", "何知秋"],
    director: "陈默然",
    status: "已上映",
    rating: 8.8,
    popularity: 5890,
    updateTime: "2022-09-30",
    synopsis:
      "在外打拼十二年的陈默，终于买上了回家的车票。一趟为期三十小时的绿皮火车，串起了三节车厢里陌生人的悲欢，也让他重新面对自己逃避多年的家庭。列车到站的那一刻，他才明白，归途本身，就是答案。",
    tags: ["现实", "亲情", "公路片"],
    recommendIds: ["d008", "d015", "d017"],
  },
  {
    id: "d010",
    title: "仙门问道",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Xianxia%20immortal%20cultivation%20drama%20poster%20art%2C%20young%20cultivator%20standing%20on%20a%20floating%20peak%20above%20clouds%2C%20deep%20navy%20sky%20and%20warm%20amber%20energy%2C%20minimalist%20fantasy%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Floating%20immortal%20mountain%20peaks%20above%20a%20sea%20of%20clouds%2C%20deep%20navy%20sky%20and%20warm%20amber%20spiritual%20glow%2C%20stylized%20fantasy%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-10&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["仙侠", "奇幻", "爱情"],
    cast: ["楚见月", "林清源", "苏晚晴"],
    director: "叶南舟",
    status: "更新至 32 集",
    rating: 8.2,
    popularity: 9430,
    updateTime: "2025-10-08",
    synopsis:
      "凡人少年沈砚为救妹妹误入仙门，资质平庸却心志坚韧。在等级森严的修真世界里，他从最底层的杂役弟子一步步逆天改命，也卷入了仙门与魔道延续千年的旧怨。问道之路上，他最终要回答的，是力量的尽头究竟是什么。",
    tags: ["逆袭", "修真", "大男主"],
    recommendIds: ["d004", "d007", "d001"],
  },
  {
    id: "d011",
    title: "商海浮沉",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Business%20drama%20poster%20art%2C%20confident%20figure%20before%20a%20city%20skyline%20at%20dusk%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimalist%20modern%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Modern%20financial%20district%20skyscrapers%20at%20dusk%2C%20deep%20navy%20glass%20facades%20with%20warm%20amber%20sunset%20reflection%2C%20stylized%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-11&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "商战"],
    cast: ["白景行", "江若彤", "温以宁"],
    director: "沈嘉木",
    status: "全 34 集 · 已完结",
    rating: 8.3,
    popularity: 7320,
    updateTime: "2024-05-22",
    synopsis:
      "三十岁那年，技术出身的方舟临危受命，接手濒临破产的家族企业。面对资本围猎、内部掣肘与昔日伙伴的背叛，他在商海的惊涛骇浪中一次次被迫重新选择。这是一场关于理想与现实的博弈，也是一代创业者成长的缩影。",
    tags: ["创业", "职场", "商战"],
    recommendIds: ["d002", "d008", "d014"],
  },
  {
    id: "d012",
    title: "锦绣芳华",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Palace%20costume%20drama%20poster%20art%2C%20elegant%20lady%20in%20embroidered%20robe%20before%20a%20silk%20screen%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimalist%20refined%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-12&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20hall%20with%20silk%20curtains%20and%20amber%20candles%2C%20deep%20navy%20shadows%2C%20stylized%20refined%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-12&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "剧情", "爱情"],
    cast: ["苏晚晴", "楚见月", "顾长风"],
    director: "陈默然",
    status: "更新至 28 集",
    rating: 8.1,
    popularity: 8650,
    updateTime: "2025-09-30",
    synopsis:
      "织女出身的柳锦儿凭借一手绝技入宫成为尚衣局绣娘。她以针线为刃，在步步惊心的宫廷中守护家族清白，也见证了权力如何改变人心。锦绣华服的背后，是一个女子以一己之力对抗命运的传奇。",
    tags: ["宫斗", "大女主", "女性成长"],
    recommendIds: ["d001", "d004", "d010"],
  },
  {
    id: "d013",
    title: "时间旅人",
    type: "电影",
    category: "movie",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Time%20travel%20science%20fiction%20movie%20poster%20art%2C%20figure%20walking%20through%20a%20glowing%20clock%20portal%2C%20deep%20navy%20void%20and%20warm%20amber%20light%2C%20minimalist%20cinematic%20background%2C%20high%20detail&width=400&height=600&seq=drama-cover-13&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Abstract%20time%20portal%20with%20concentric%20glowing%20rings%2C%20deep%20navy%20void%20and%20warm%20amber%20energy%2C%20stylized%20sci-fi%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-13&orientation=landscape",
    year: 2023,
    region: "美国",
    genres: ["科幻", "悬疑", "剧情"],
    cast: ["陆星辰", "温以宁"],
    director: "叶南舟",
    status: "已上映",
    rating: 8.6,
    popularity: 6410,
    updateTime: "2023-03-10",
    synopsis:
      "物理学家艾伦发明了一台只能回到过去的装置。为了阻止一场悲剧，他一次次重启同一天，却发现每一次改变都会带来更难以承受的代价。当记忆开始错乱，他必须决定：是放下执念，还是在时间的迷宫里永远徘徊。",
    tags: ["时间循环", "烧脑", "宿命"],
    recommendIds: ["d003", "d007", "d006"],
  },
  {
    id: "d014",
    title: "谍影风云",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Spy%20thriller%20drama%20poster%20art%2C%20figure%20in%20a%20long%20coat%20in%20a%20foggy%20old%20city%20street%2C%20deep%20navy%20mist%20and%20warm%20amber%20lamp%2C%20minimalist%20moody%20background%2C%20high%20detail&width=400&height=600&seq=drama-cover-14&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Foggy%20old%20city%20street%20at%20night%20with%20amber%20lamps%2C%20deep%20navy%20mist%20and%20long%20shadows%2C%20stylized%20espionage%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-14&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["谍战", "悬疑", "剧情"],
    cast: ["顾长风", "江若彤", "白景行"],
    director: "沈嘉木",
    status: "全 38 集 · 已完结",
    rating: 8.9,
    popularity: 7990,
    updateTime: "2024-08-28",
    synopsis:
      "代号“夜莺”的潜伏者周砚在敌人心脏深处独自坚守十二年。当新的联络人到来，他必须在天罗地网中完成几乎不可能的任务。情报、背叛、生死一线，他把名字和过往都藏进了黑暗，只为等来黎明。",
    tags: ["谍战", "高智商", "信仰"],
    recommendIds: ["d002", "d006", "d011"],
  },
  {
    id: "d015",
    title: "家和万事兴",
    type: "电视剧",
    category: "tv",
    isClassic: true,
    cover:
      "https://readdy.ai/api/search-image?query=Family%20drama%20poster%20art%2C%20warm%20family%20gathered%20around%20a%20dinner%20table%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimalist%20cozy%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-15&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cozy%20family%20dining%20room%20with%20warm%20amber%20lamp%20light%20and%20deep%20navy%20evening%20shadows%2C%20nostalgic%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-15&orientation=landscape",
    year: 2021,
    region: "中国大陆",
    genres: ["家庭", "剧情", "喜剧"],
    cast: ["温以宁", "林清源", "何知秋"],
    director: "陈默然",
    status: "全 40 集 · 已完结",
    rating: 8.2,
    popularity: 5230,
    updateTime: "2021-05-16",
    synopsis:
      "老城改造在即，三代同堂的李家面临搬与不搬的选择。老爷子舍不得老院，儿女各有各的算盘，一件件鸡毛蒜皮的小事，串起了一个普通中国家庭几十年的悲欢。吵吵闹闹之后，他们终于明白：家，永远是最后的港湾。",
    tags: ["经典", "温情", "合家欢"],
    recommendIds: ["d009", "d008", "d005"],
  },
  {
    id: "d016",
    title: "燃情岁月",
    type: "电影",
    category: "movie",
    isClassic: true,
    cover:
      "https://readdy.ai/api/search-image?query=Period%20drama%20movie%20poster%20art%2C%20silhouettes%20of%20workers%20against%20a%20fiery%20sunset%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimalist%20epic%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-16&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Vintage%20industrial%20town%20at%20sunset%20with%20warm%20amber%20sky%20and%20deep%20navy%20silhouettes%2C%20epic%20nostalgic%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-16&orientation=landscape",
    year: 2020,
    region: "中国大陆",
    genres: ["年代", "剧情", "家庭"],
    cast: ["顾长风", "白景行"],
    director: "叶南舟",
    status: "已上映",
    rating: 8.5,
    popularity: 4870,
    updateTime: "2020-10-20",
    synopsis:
      "上世纪八十年代，一群年轻人在改革的浪潮中走进工厂。他们用双手建设城市，也在时代的洪流里经历爱情、友情与理想的碰撞。三十年后再回望，那些燃烧过的青春，成了这座城市最深的底色。",
    tags: ["经典", "年代", "群像"],
    recommendIds: ["d009", "d015", "d008"],
  },
  {
    id: "d017",
    title: "微光之城",
    type: "电影",
    category: "movie",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Art%20house%20film%20poster%20art%2C%20lone%20figure%20on%20a%20quiet%20city%20bridge%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20amber%20streetlights%2C%20minimalist%20poetic%20background%2C%20high%20detail&width=400&height=600&seq=drama-cover-17&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Quiet%20city%20bridge%20over%20a%20river%20at%20night%2C%20deep%20navy%20sky%20and%20warm%20amber%20streetlights%20reflected%20on%20water%2C%20poetic%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-17&orientation=landscape",
    year: 2025,
    region: "中国台湾",
    genres: ["剧情", "文艺"],
    cast: ["何知秋", "苏晚晴"],
    director: "沈嘉木",
    status: "已上映",
    rating: 8.0,
    popularity: 4320,
    updateTime: "2025-06-12",
    synopsis:
      "夜班便利店店员、深夜电台主播和一位总在同一时间路过的陌生人，在这座城市的角落里各自沉默。一次偶然的交集，让三个原本平行的生活有了微光。没有惊天动地的故事，只有普通人彼此照亮的温柔瞬间。",
    tags: ["文艺", "治愈", "城市"],
    recommendIds: ["d009", "d005", "d015"],
  },
  {
    id: "d018",
    title: "笑傲都市",
    type: "电视剧",
    category: "tv",
    isClassic: false,
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20comedy%20drama%20poster%20art%2C%20cheerful%20group%20of%20friends%20in%20a%20bright%20cafe%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20minimalist%20playful%20background%2C%20artistic%20high%20detail&width=400&height=600&seq=drama-cover-18&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20cafe%20interior%20with%20warm%20amber%20light%20and%20deep%20navy%20accent%20furniture%2C%20playful%20cheerful%20cinematic%20mood%2C%20artistic%20abstract%20composition%2C%20high%20detail&width=1600&height=700&seq=banner-18&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "都市", "剧情"],
    cast: ["林清源", "温以宁"],
    director: "叶南舟",
    status: "全 26 集 · 已完结",
    rating: 7.7,
    popularity: 6120,
    updateTime: "2024-04-14",
    synopsis:
      "失业又失恋的程序员老周，阴差阳错接手了一家快倒闭的社区咖啡馆。一群性格各异的常客把这里当成了树洞，鸡飞狗跳的日常里藏着最真实的都市冷暖。笑着笑着，眼泪就下来了。",
    tags: ["轻喜剧", "群像", "治愈"],
    recommendIds: ["d005", "d011", "d015"],
  },
];

export const dramaMap: Record<string, Drama> = dramas.reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {} as Record<string, Drama>
);

export function getDramaById(id: string): Drama | undefined {
  return dramaMap[id];
}